<div class="background"></div>

<mat-card appearance="outlined" *ngIf="!isLoading">
  <router-outlet name="authentication"></router-outlet>
</mat-card>

<mat-spinner *ngIf="isLoading"></mat-spinner>

